import { render, staticRenderFns } from "./promise-confirm-dialog.vue?vue&type=template&id=1300048d&scoped=true&"
import script from "./promise-confirm-dialog.vue?vue&type=script&lang=js&"
export * from "./promise-confirm-dialog.vue?vue&type=script&lang=js&"
import style0 from "./promise-confirm-dialog.vue?vue&type=style&index=0&id=1300048d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1300048d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardActions,VCardText,VDialog,VIcon})
